import { BaseComponent } from "../base/baseComponent";
import { CompType } from "../base/baseEnum";
import { type GameItem } from "../base/baseType";

/** 猜你喜欢组件类 */
export class TournamentComponent extends BaseComponent<{
  [key: string]: string | number | boolean | object | null | undefined;
}> {
  public list: GameItem[] = [];

  constructor(
    data: Partial<
      BaseComponent<{
        [key: string]: string | number | boolean | object | null | undefined;
      }>
    > = {},
  ) {
    super(data);
    this.type = CompType.champion_ship;
  }

  /** 获取标题 */
  public getTitle(): string {
    return this.title || "";
  }
}
